


// import React from 'react';
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     IconButton,
//     Typography,
//     Grid,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Paper,
//     Box,
//     Divider,
//     Button,
//     Stack,
// } from '@mui/material';
// import { MdCancel } from "react-icons/md";
// import "../../../OperatorRegistration/Modal/TableDataViewModal.css";
// import documentImage from "../../../../Assets/Emirates_ID_Card_For_UAE_Citizens_(New).png"


// const RegistrationDetailsModal = ({ open, onClose, modalViewHeadingName }) => {
//     const purchaser = {
//         firstName: 'Mani',
//         lastName: 'Krish',
//         email: 'manikrish@gmail.com',
//         mobileNumber: '9823281781',
//         userType: 'Individual',
//         documentType: 'Emirates ID',
//         addressLine1: 'CL-720',
//         addressLine2: 'Afza, Ajman',
//         city: 'Al Ain',
//         state: 'Abu Dhabi',
//         country: 'United Arab Emirates',
//         zipcode: '20000',
//         schemes: [
//             {
//                 name: 'Mani Krish',
//                 email: 'manikrish@gmail.com',
//                 useType: 'Financial Consultant',
//                 JoindOnDate: '15 Jan 2025',

//             },
//         ],
//     };
//     const TableHeadModalData = ["Referrer Name", "Email", "User Type", 'Joined on']

//     const Documents = [documentImage, documentImage, documentImage]

//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             fullWidth
//             maxWidth="md"
//             className="custom-dialog"
//             sx={{
//                 "& .MuiPaper-root": {
//                     borderRadius: "14px",
//                 },
//             }}
//         >
//             <Box sx={{ position: 'relative' }}>
//                 {/* Dialog Header */}
//                 <Box className="dialog-heading">
//                     <IconButton
//                         aria-label="Close"
//                         onClick={onClose}
//                         sx={{
//                             position: 'absolute',
//                             top: 8,
//                             right: 8,
//                             color: 'text.secondary',
//                         }}
//                     >
//                         <MdCancel />
//                     </IconButton>
//                     <DialogTitle className="custom-dialog-title">
//                         <Typography className="custom-title-text" color="white">
//                             {modalViewHeadingName}
//                         </Typography>
//                     </DialogTitle>
//                 </Box>
//             </Box>

//             <DialogContent>
//                 <Box p={{ xs: 2, md: 1 }}>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>
//                         {/* Aligning using flex and justifyContent */}


//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     First Name
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.firstName}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Last Name
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.lastName}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     User Type
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.userType}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Email
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.email}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Mobile Number
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.mobileNumber}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Document Type
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.documentType}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Address Line 1
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.addressLine1}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Address Line 2
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.addressLine2}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     City
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.city}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     State
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.state}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     country
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.country}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Zipcode
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.zipcode}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>


//                     <Divider sx={{ mt: 3 }} />

//                     {/* Schemes Table */}
//                     <Box mt={4}>
//                         <Typography variant="body2" gutterBottom>
//                             Referred By
//                         </Typography>
//                         <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
//                             <Table sx={{ borderCollapse: 'collapse' }}>
//                                 <TableHead>
//                                     <TableRow sx={{ p: "16px 0" }}>
//                                         {TableHeadModalData.map((data, index) => (

//                                             <TableCell sx={{
//                                                 color: "#7A7A7A", border: "none", p: "10px 10px 0 0px", whiteSpace: 'nowrap',
//                                                 textOverflow: 'ellipsis',
//                                             }}>
//                                                 <Typography variant='body1'> {data}</Typography></TableCell>
//                                         ))}
//                                     </TableRow>
//                                 </TableHead>

//                                 <TableBody>
//                                     {purchaser.schemes.map((scheme, index) => (
//                                         <TableRow key={index}>
//                                             {Object.keys(scheme).map((key) => (
//                                                 <TableCell key={key} sx={{
//                                                     border: "none", p: "10px 10px 0 0px", whiteSpace: 'nowrap',
//                                                     textOverflow: 'ellipsis',
//                                                 }} >
//                                                     <Typography variant='subtitle2'>
//                                                         {scheme[key]}
//                                                     </Typography>
//                                                 </TableCell>
//                                             ))}
//                                         </TableRow>
//                                     ))}
//                                 </TableBody>

//                             </Table>
//                         </TableContainer>
//                     </Box>
//                     <Divider sx={{ mt: 3 }} />

//                     <Grid mt={1} sx={{ display: "flex", justifyContent: "end" }}>

//                         <Stack spacing={2} direction="row">
//                             <Button
//                                 variant="contained"
//                                 // onClick={handleGoStakeNowPage}

//                                 sx={{
//                                     // backgroundColor: "#C38F51",
//                                     textTransform: "none",
//                                     color: "#F53E5C",
//                                     fontSize: "16px",
//                                     // padding: "0px 40px",
//                                     padding: { xs: "0px 20px", md: "0px 40px" },

//                                     minHeight: "40px",
//                                     borderRadius: "23px",
//                                     boxShadow: "none",
//                                     border: "1px solid #F53E5C",
//                                     background: "white 0% 0% no-repeat padding-box",
//                                     // "&:hover": {
//                                     //     backgroundColor: "#3B4056",
//                                     // },
//                                 }}
//                             >
//                                 {/* {bannerDates?.[0]?.additional_data?.[0]?.primary_button_text || "Primary Button"} */}
//                                 Reject
//                             </Button>
//                             <Button
//                                 variant="outlined"
//                                 // onClick={handleGoLoginpage}
//                                 sx={{
//                                     // backgroundColor: "#FFAA17",
//                                     border: "1px solid #1FC45B",
//                                     textTransform: "none",
//                                     boxShadow: "none",
//                                     color: "white",
//                                     fontSize: "16px",
//                                     padding: { xs: "0px 20px", md: "0px 40px" },
//                                     minHeight: "40px",
//                                     borderRadius: "23px",
//                                     // font: "normal normal normal 16px / 25px Roboto",
//                                     letterSpacing: "0px",
//                                     color: "white",
//                                     background: "#1FC45B"
//                                     // "&:hover": {
//                                     //     backgroundColor: "#C38F51",
//                                     // },
//                                 }}
//                             >
//                                 {/* {bannerDates?.[0]?.additional_data?.[0]?.secondary_button_text || "Secondary Button"} */}
//                                 Approve
//                             </Button>
//                         </Stack>
//                     </Grid>

//                 </Box>
//             </DialogContent>
//         </Dialog >
//     );
// };

// export default RegistrationDetailsModal;






import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box,
    Divider,
    Button,
    Stack,
} from '@mui/material';
import { MdCancel } from "react-icons/md";
import "../../../OperatorRegistration/Modal/TableDataViewModal.css";
// import documentImage from "../../../Assets/Emirates_ID_Card_For_UAE_Citizens_(New).png"
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../../ReduxStore/actions/index";
import { adminUrl } from "../../../../constants/url"
import { toast, ToastContainer } from 'react-toastify';
import { Await } from 'react-router-dom';
import RejectCommendModal from './RejectCommendModal';
import { clearTableGetId } from '../../../../ReduxStore/Slices/TableId/TableIdGetSlice';
import { clearCustomerId } from '../../../../ReduxStore/Slices/Operator/customerSlice';


const RegistrationDetailsModal = ({ open, onClose, modalViewHeadingName, userApprovalModel, showApproveButton, showRejectCommand }) => {

    const handleDownload = (fileUrl, fileName) => {
        fetch(fileUrl)
            .then(response => response.blob()) // Convert response to blob
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = fileName; // Set filename
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url); // Clean up memory
            })
            .catch(error => console.error("Download error:", error));
    };

    console.log(adminUrl, "adminUrladminUrladminUrl");


    const dispatch = useDispatch();
    const purchaser = {
        firstName: 'Mani',
        lastName: 'Krish',
        email: 'manikrish@gmail.com',
        mobileNumber: '9823281781',
        userType: 'Individual',
        documentType: 'Emirates ID',
        addressLine1: 'CL-720',
        addressLine2: 'Afza, Ajman',
        city: 'Al Ain',
        state: 'Abu Dhabi',
        country: 'United Arab Emirates',
        zipcode: '20000',
        schemes: [
            {
                name: 'Mani Krish',
                email: 'manikrish@gmail.com',
                useType: 'Financial Consultant',
                JoindOnDate: '15 Jan 2025',

            },
        ],
    };
    const TableHeadModalData = ["Referrer Name", "Email", "User Type", 'Joined on']

    // const Documents = [documentImage, documentImage, documentImage]


    const { getCustomerById } = useSelector((state) => state?.getCustomerById);
    const customerId = useSelector((state) => state.customer.customerId);
    console.log(customerId, "customerIdddddd")
    console.log(getCustomerById?.data, "getAllCustomersStatusgetAllCustomersStatus");

    useEffect(() => {
        if (!open) return;

        const fetchData = async () => {
            if (customerId) {
                const data1 = { data: {}, method: "get", apiName: `getCustomerById/${customerId}` };
                await dispatch(actions.GETCUSTOMERBYID(data1));
            }
        };
        fetchData();
    }, [dispatch, customerId]);



    const [isRejectCommendModalopen, setRejectCommendModalopen] = useState(false);

    const handleRejectCommendOpenModal = () => {
        setRejectCommendModalopen(true);
    };

    const handleRejectCommendCloseModal = () => {
        setRejectCommendModalopen(false);
        dispatch(clearTableGetId(null))
        dispatch(clearCustomerId(null))

    };


    const [rowTableData, setRowTableData] = useState({
        firstName: 'Mani',
        lastName: 'Krish',
        email: 'manikrish@gmail.com',
        mobileNumber: '9823281781',
        userType: 'Individual',
        documentType: 'Emirates ID',
        addressLine1: 'CL-720',
        addressLine2: 'Afza, Ajman',
        city: 'Al Ain',
        state: 'Abu Dhabi',
        country: 'United Arab Emirates',
        zipcode: '20000',
        kycPdf: []
        // schemes: [
        //     {
        //         name: 'Mani Krish',
        //         email: 'manikrish@gmail.com',
        //         useType: 'Financial Consultant',
        //         JoindOnDate: '15 Jan 2025',

        //     },
        // ],
    });

    useEffect(() => {
        const tempArr = [];
        // getCustomerById?.data?.map((data, index) => {

        //     return tempArr.push({
        //         Name: `${data?.first_name} ${data?.last_name}`,
        //         customer_id: data?.customer_id,
        //         email: data?.email,
        //         phone: data?.phone,
        //         role: data?.role === "customer" ? "Individual" : data?.role,
        //         approval_status: data?.approval_status.charAt(0).toUpperCase() + data?.approval_status.slice(1),
        //     });
        // });

        if (customerId && getCustomerById?.data) {
            setRowTableData({
                firstName: getCustomerById?.data?.first_name,
                lastName: getCustomerById?.data?.last_name,
                customer_id: getCustomerById?.data?.customer_id,
                email: getCustomerById?.data?.email,
                mobileNumber: getCustomerById?.data?.phone,
                userType: getCustomerById?.data?.role === "customer" ? "Individual" : getCustomerById?.data?.role,
                documentType: 'Emirates ID',
                addressLine1: getCustomerById?.data?.address_1,
                addressLine2: getCustomerById?.data?.address_2,
                city: getCustomerById?.data?.city,
                state: getCustomerById?.data?.state,
                country: getCustomerById?.data?.country,
                zipcode: getCustomerById?.data?.zip_code,
                kycPdf: getCustomerById?.data?.kycPdf
                // schemes: [
                //     {
                //         name: 'Mani Krish',
                //         email: 'manikrish@gmail.com',
                //         useType: 'Financial Consultant',
                //         JoindOnDate: '15 Jan 2025',

                //     },
                // ],

            });
        }
    }, [dispatch, getCustomerById]);



    const { approveCustomer } = useSelector((state) => state?.approveCustomer);

    const customerRegisterApprove = async (id) => {
        console.log(id, "customerRegisterApprovecustomerRegisterApprove");

        const data1 = { data: {}, method: "patch", apiName: `approveCustomer/${id}` };
        const approveCustomerResponse = await dispatch(actions.APPROVECUSTOMER(data1));

        console.log(approveCustomerResponse.payload.message, "approveCustomerResponse");

        if (approveCustomerResponse.payload.message === "Customer status changed to approved successfully.") {

            toast.success("Approved Successfully.")
            setTimeout(() => onClose(), 1500)
            dispatch(clearTableGetId(null))
            dispatch(clearCustomerId(null))

        }

        if (approveCustomerResponse.payload.message === "Customer is already approved.") {

            toast.error("Customer is already approved.")
            setTimeout(() => onClose(), 1500)
        }

    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            className="custom-dialog"
            sx={{
                "& .MuiPaper-root": {
                    borderRadius: "14px",
                },
            }}
        >

            {/* <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark" /> */}

            <Box sx={{ position: 'relative' }}>
                {/* Dialog Header */}
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        onClick={() => {
                            onClose()
                            dispatch(clearTableGetId(null))
                            dispatch(clearCustomerId(null))

                        }}
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            color: 'text.secondary',
                        }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">
                        <Typography className="custom-title-text" color="white">
                            {modalViewHeadingName}
                        </Typography>
                    </DialogTitle>
                </Box>
            </Box>

            <DialogContent>
                <Box p={{ xs: 2, md: 1 }}>
                    <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>
                        {/* Aligning using flex and justifyContent */}


                        <Grid item >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    First Name
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.firstName}</Typography>
                            </Box>
                        </Grid>
                        <Grid item >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Last Name
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.lastName}</Typography>
                            </Box>
                        </Grid>
                        <Grid item  >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    User Type
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.userType}</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

                        <Grid item >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Email
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.email}</Typography>
                            </Box>
                        </Grid>
                        <Grid item  >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Mobile Number
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.mobileNumber}</Typography>
                            </Box>
                        </Grid>
                        <Grid item  >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Document Type
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.documentType}</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

                        <Grid item >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Address Line 1
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.addressLine1}</Typography>
                            </Box>
                        </Grid>
                        <Grid item >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Address Line 2
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.addressLine2}</Typography>
                            </Box>
                        </Grid>
                        <Grid item  >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    City
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.city}</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

                        <Grid item  >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    State
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.state}</Typography>
                            </Box>
                        </Grid>
                        <Grid item >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    country
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.country}</Typography>
                            </Box>
                        </Grid>
                        <Grid item  >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Zipcode
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.zipcode}</Typography>
                            </Box>
                        </Grid>
                    </Grid>


                    <Divider sx={{ mt: 3 }} />

                    {/* Schemes Table */}
                    <Box mt={4}>
                        <Typography variant="body2" gutterBottom>
                            Customer Document
                        </Typography>
                        {/* <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                            <Table sx={{ borderCollapse: 'collapse' }}>
                                <TableHead>
                                    <TableRow sx={{ p: "16px 0" }}>
                                        {rowTableData?.kycPdf?.map((data, index) => (

                                            <TableCell sx={{
                                                color: "#7A7A7A", border: "none", p: "10px 10px 0 0px", whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                            }}>
                                                <Typography variant='body1'> {data.type}</Typography></TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {rowTableData?.kycPdf?.map((scheme, index) => (

                

                                     <TableRow key={index}>

                                        <TableCell key={index} sx={{
                                            border: "none", p: "10px 10px 0 0px", whiteSpace: 'nowrap',
                                            textOverflow: 'ellipsis',
                                        }} >
                                            
                                            <Grid item xs={12} md={4} key={index}>
                                                <Box sx={{ p: 1, background: "white", boxShadow: 2, borderRadius: "5px" }}>
                                                    <Box
                                                        component="img"
                                                        src={`https://goldstakebackend.cygnusa.in/api/v1/${scheme.fileUrl}`}
                                                        height="200px"
                                                        width="100%"
                                                        display="block"
                                                        margin="0" // Center the image within the grid cell
                                                    />
                                                </Box>
                                            </Grid>
                                        </TableCell>

                                    </TableRow>
                                    ))}
                                </TableBody>

                            </Table>
                        </TableContainer> */}
                        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                            <Box sx={{ overflowX: "auto" }}> {/* Enables horizontal scrolling on small screens */}
                                <Table sx={{ borderCollapse: "collapse", minWidth: 650 }}>
                                    {/* Table Head */}
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ color: "#7A7A7A", fontWeight: "bold", borderBottom: "1px solid #ddd", p: "10px" }}>
                                                Type
                                            </TableCell>
                                            <TableCell sx={{ color: "#7A7A7A", fontWeight: "bold", borderBottom: "1px solid #ddd", p: "10px" }}>
                                                File Preview
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    {/* Table Body */}
                                    <TableBody sx={{ width: "100%" }}>
                                        {rowTableData?.kycPdf?.map((scheme, index) => {
                                            const fileUrl = scheme.fileUrl;
                                            const isImage = fileUrl.startsWith("uploads/images/");
                                            const isPdf = fileUrl.startsWith("uploads/pdfs/");

                                            return (
                                                <TableRow key={index}>
                                                    {/* Type Column */}
                                                    <TableCell sx={{ borderBottom: "1px solid #ddd", p: "10px", whiteSpace: "nowrap" }}>
                                                        {scheme.type}
                                                    </TableCell>

                                                    {/* File Preview Column */}
                                                    {/* <TableCell sx={{ borderBottom: "1px solid #ddd", p: "10px" }}>
                                                        <Grid item xs={12} md={12}>
                                                            <Box sx={{ p: 1, background: "white", boxShadow: 2, borderRadius: "5px" }}>
                                                                {isImage ? (
                                                                    <Box
                                                                        component="img"
                                                                        src={`${adminUrl}${fileUrl}`}
                                                                        sx={{
                                                                            width: "100%",
                                                                            height: { xs: "150px", sm: "250px", lg: "350px" }, // Responsive height
                                                                            objectFit: "cover",
                                                                            display: "block",
                                                                        }}
                                                                        alt="Image"
                                                                    />
                                                                ) : isPdf ? (
                                                                    // <iframe
                                                                    //     src={`${adminUrl}${fileUrl}`}
                                                                    //     style={{
                                                                    //         width: "100%",
                                                                    //         height: "100%",
                                                                    //         minHeight: "350px",
                                                                    //         maxHeight: "350px",
                                                                    //     }}
                                                                    //     title="PDF Document"
                                                                    // ></iframe>

                                                                    <Box
                                                                        component="iframe"
                                                                        src={`${adminUrl}${fileUrl}`}
                                                                        sx={{
                                                                            width: "100%",
                                                                            height: { xs: "150px", sm: "250px", lg: "350px" }, // Responsive height
                                                                            objectFit: "cover",
                                                                            display: "block",
                                                                        }}
                                                                        alt="PDF Document"
                                                                    />
                                                                ) : (
                                                                    "Invalid File Type"
                                                                )}
                                                            </Box>
                                                        </Grid>
                                                    </TableCell> */}


                                                    <TableCell sx={{ borderBottom: "1px solid #ddd", p: "10px" }}>
                                                        <Grid item xs={12} md={12}>
                                                            <Box sx={{ p: 1, background: "white", boxShadow: 2, borderRadius: "5px" }}>
                                                                {isImage ? (
                                                                    <>
                                                                        <Box
                                                                            component="img"
                                                                            src={`${adminUrl}${fileUrl}`}
                                                                            sx={{
                                                                                width: "100%",
                                                                                height: { xs: "150px", sm: "250px", lg: "325px" }, // Responsive height
                                                                                objectFit: "cover",
                                                                                display: "block",
                                                                            }}
                                                                            alt="Image"
                                                                        />
                                                                        {/* Button to trigger download */}
                                                                        <Button
                                                                            // variant="contained"
                                                                            // color="#C38F51"
                                                                            sx={{
                                                                                mt: 1, width: "100%", textTransform: "none",
                                                                                background: "#C38F51",
                                                                                color: "white",
                                                                                fontSize: "16px",
                                                                                fontWeight: "700",
                                                                                minHeight: "30px",
                                                                                borderRadius: "5px",
                                                                            }}
                                                                            onClick={() => handleDownload(`${adminUrl}${fileUrl}`, `${scheme.type}-${rowTableData.customer_id}`)}
                                                                        >
                                                                            Download Image
                                                                        </Button>
                                                                    </>
                                                                ) : isPdf ? (
                                                                    <>
                                                                        <Box
                                                                            component="iframe"
                                                                            src={`${adminUrl}${fileUrl}`}
                                                                            sx={{
                                                                                width: "100%",
                                                                                height: { xs: "150px", sm: "250px", lg: "325px" }, // Responsive height
                                                                                objectFit: "cover",
                                                                                display: "block",
                                                                            }}
                                                                            title="PDF Document"
                                                                        />
                                                                        {/* Button to trigger download */}
                                                                        <Button

                                                                            sx={{
                                                                                mt: 1, width: "100%", textTransform: "none",
                                                                                background: "#C38F51",
                                                                                color: "white",
                                                                                fontSize: "16px",
                                                                                fontWeight: "700",
                                                                                minHeight: "30px",
                                                                                borderRadius: "5px",
                                                                            }}
                                                                            onClick={() => handleDownload(`${adminUrl}${fileUrl}`, `${scheme.type}-${rowTableData.customer_id}`)}
                                                                        >
                                                                            Download PDF
                                                                        </Button>
                                                                    </>
                                                                ) : (
                                                                    "Invalid File Type"
                                                                )}
                                                            </Box>
                                                        </Grid>
                                                    </TableCell>

                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </Box>
                        </TableContainer>


                    </Box>

                    {showRejectCommand && (
                        <>
                            <Divider sx={{ mt: 3 }} />
                            <Box sx={{ background: "rgb(245 62 92 / 40%)", p: 2 }}>
                                <Typography variant='body2'>
                                    Reject Command:
                                </Typography>
                                <Typography variant='body1' sx={{ marginLeft: "10px", mt: 1 }}>
                                    {getCustomerById?.data?.reject_comment}
                                </Typography>
                            </Box>
                        </>

                    )}

                    {/* <Grid xs={12} mt={1}>
                        <Typography variant="body2">
                            Documents
                        </Typography>
                        <Grid container spacing={2} mt={1}>
                            {Documents.map((data, index) => (
                                <Grid item xs={12} md={4} key={index}>
                                    <Box sx={{ p: 1, background: "white", boxShadow: 2, borderRadius: "5px" }}>
                                        <Box
                                            component="img"
                                            src={data}
                                            height="200px"
                                            width="100%"
                                            display="block"
                                            margin="0" // Center the image within the grid cell
                                        />
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid> */}

                    {showApproveButton && (
                        <>
                            <Divider sx={{ mt: 3 }} />


                            <Grid mt={1} sx={{ display: "flex", justifyContent: "end" }}>

                                <Stack spacing={2} direction="row">
                                    <Button
                                        variant="contained"
                                        onClick={handleRejectCommendOpenModal}

                                        sx={{
                                            // backgroundColor: "#C38F51",
                                            textTransform: "none",
                                            color: "#F53E5C",
                                            fontSize: "16px",
                                            // padding: "0px 40px",
                                            padding: { xs: "0px 20px", md: "0px 40px" },

                                            minHeight: "40px",
                                            borderRadius: "23px",
                                            boxShadow: "none",
                                            border: "1px solid #F53E5C",
                                            background: "white 0% 0% no-repeat padding-box",
                                            // "&:hover": {
                                            //     backgroundColor: "#3B4056",
                                            // },
                                        }}
                                    >
                                        {/* {bannerDates?.[0]?.additional_data?.[0]?.primary_button_text || "Primary Button"} */}
                                        Reject
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => {
                                            customerRegisterApprove(rowTableData.customer_id)
                                        }}
                                        sx={{
                                            // backgroundColor: "#FFAA17",
                                            border: "1px solid #1FC45B",
                                            textTransform: "none",
                                            boxShadow: "none",
                                            color: "white",
                                            fontSize: "16px",
                                            padding: { xs: "0px 20px", md: "0px 40px" },
                                            minHeight: "40px",
                                            borderRadius: "23px",
                                            // font: "normal normal normal 16px / 25px Roboto",
                                            letterSpacing: "0px",
                                            color: "white",
                                            background: "#1FC45B"
                                            // "&:hover": {
                                            //     backgroundColor: "#C38F51",
                                            // },
                                        }}
                                    >
                                        {/* {bannerDates?.[0]?.additional_data?.[0]?.secondary_button_text || "Secondary Button"} */}
                                        Approve
                                    </Button>
                                </Stack>
                            </Grid>
                        </>
                    )}
                </Box>

            </DialogContent>
            <RejectCommendModal
                open={isRejectCommendModalopen}
                onClose={handleRejectCommendCloseModal}
                onSchemeApprovalModalClose={onClose}
            />
        </Dialog >
    );
};

export default RegistrationDetailsModal;
